<template>
<v-flex d-flex>
    <v-container fluid>
<v-card>
  
<v-card-title primary-title>
  <h1 class="headline font-weight-light">BUYBACK</h1>
</v-card-title>
<v-card>
  <v-card-title primary-title>
    <span class="headline font-weight-light">Review Config</span>
  </v-card-title>
  <v-container fluid>
    <v-layout pt-3>
      <v-autocomplete
        class="ml-0"
        v-model="selected"
        :options="configs"
        :items="configs"
        :loading="loading"
        item-text="name"
        cache-items
        label="Select Client Configs"
        
      ></v-autocomplete>
    </v-layout>
    <div  v-if="this.config.length > 0 ">
      <h4 class="title font-weight-light" style= "padding: 5px;" > Select Client : {{this.config[0].clientConfigName}}</h4>
    <h4 class="title font-weight-light" style= "padding: 5px;" > Description: - {{ this.config[0].description ? this.config[0].description : 'No description'}}</h4>
    <h4 class="subheading font-weight-light" style= "padding: 5px;">updated_at : {{ this.config[0].updated_at ? this.config[0].updated_at : '-'}}</h4>
  </div>

  </v-container>
</v-card>

<v-card>
  <v-card-title primary-title>
    <span class="headline font-weight-light">Account</span>
  </v-card-title>
  <v-card-text>
    <v-container>
      <template>
  <div>
    <v-data-table 
      v-if="selected && selectConfigs.length > 0"
      :headers="headerConfig"
      :items="selectConfigs"
      class="elevation-1"
      hide-actions
      small
      :max-width="500"
    >
      <template v-slot:items="props">
        <td>
          <div class=" custom-style-for-table text-uppercase font-weight-light" v-for="(bot, index) in props.item.exchange" :key="index">{{ bot }}</div>
        </td>
        <td>
          <div class=" custom-style-for-table font-weight-light" v-for="(bot, index) in props.item.execution" :key="index">{{ bot }}</div>
        </td>
        <td>
          <div class=" custom-style-for-table font-weight-light" v-for="(bot, index) in props.item.support" :key="index">{{ bot }}</div>
        </td>
        <td>
          <div class=" custom-style-for-table font-weight-light" v-for="(bot, index) in props.item.openOrder" :key="index">{{ bot }}</div>
        </td>
      </template>
    </v-data-table>
    <div v-else>
      <template>
  <v-data-table
    :headers="headerConfig"
    :items="[]"
    class="elevation-1"
    hide-actions
      small
      :max-width="500"
  >
    <template v-slot:no-data>
      <v-alert :value="true" color="info" icon="info">
        Select Config to show
      </v-alert>
    </template>
  </v-data-table>
</template>
    </div>
  </div>
</template>
    </v-container>
  </v-card-text>
</v-card>

<v-card>
    <v-card-title primary-title>
      <span class="headline font-weight-light">Setting</span>
    </v-card-title>
          <v-card-text class="pt-0">
            <v-form @submit.prevent="submitQuery">
              <v-container fluid>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field
                      v-model="supportPrice"
                      label="Support Price Ratio"
                      prepend-icon="mdi-content-paste"
                      type="number"
                      required
                    ></v-text-field>
                    <v-text-field
                      v-model="supportAmount"
                      label="Support Amount Ratio"
                      prepend-icon="mdi-content-paste"
                      type="number"
                      required
                    ></v-text-field>
                    <v-text-field
                      v-model="targetPrice"
                      label="Input Price ($)"
                      prepend-icon="mdi-content-paste"
                      type="number"
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
              <v-card-actions>
              <v-layout row justify-center>
                <v-btn 
                color="primary"
                type="submit" 
                :loading="loading"
                :disabled="!validForm"
                >Query</v-btn>
              </v-layout>
            </v-card-actions>
            </v-form>
          </v-card-text>

      </v-card>


<v-card >
      

    
<v-card-text>
  <div>
  <p class="text-xs-center font-weight-light" style="font-size: 60px">Total USD required</p>
  <p class="text-xs-center font-weight-light" style="font-size: 60px">{{ this.resultRaw.totalUsdToBuy ? this.resultRaw.totalUsdToBuy.toLocaleString('en-US', {style: 'currency', currency: 'USD'}) : ' - ' }}</p>
  <p class="text-xs-center font-weight-light" style="font-size: 40px">Client:  {{ this.resultRaw.client }} </p>
  <p class="text-xs-center font-weight-light" style="font-size: 40px">Date:  {{ this.resultRaw.date }} </p>
  </div>
  <v-container >
  <v-data-table
    :headers="headerResult"
    :items="result"
    class="elevation-1"
    hide-actions    
  >
    <template v-slot:items="props">
      <td ><div class="custom-style-for-table text-uppercase font-weight-light"> {{ props.item.exchangeName }} </div></td>
      <td>
        <div class="custom-style-for-table font-weight-light">{{props.item.market}}</div>
      </td>
      <td>
        <div class="custom-style-for-table font-weight-light">{{props.item.orders}}</div>
      </td>
      <td>
        <div class="custom-style-for-table font-weight-light">{{props.item.volumeToken}}</div>
      </td>
      <td>
        <div class="custom-style-for-table font-weight-light">{{props.item.volumeQuote}}</div>
      </td>
      <td>
        <div class="custom-style-for-table font-weight-light">{{props.item.volumeUSD}}</div>
      </td>
      <td>
        <div class="custom-style-for-table font-weight-light"> {{ props.item.buyOrders }}</div>
      </td>
      <td>
        <div class="custom-style-for-table font-weight-light">{{ props.item.buyOrders }}</div>
      </td>
    </template>
  </v-data-table>
</v-container>
<v-card-actions>
              <v-layout row justify-center>
                <v-btn 
                :loading="loading"
                :disabled="isResultEmpty"
                color="primary"
                type="submit" 
                @click="submitExecution"
                >Execution</v-btn>
              </v-layout>
            </v-card-actions>
</v-card-text>
</v-card>

</v-card>
  </v-container>
</v-flex>
</template>

<script>
import MessageDialog from '../../libs/message-dialog/'
import MongoConnector from '@/services/mongo-connector.service'
import MongoService from '../../services/mongo.service'
export default {
  data () {
    const service = new MongoConnector(null, 'buyback-configs', {})

    return {
      service,
      loading: false,
      selected: null,
      validQuery: false,
      validSupportPrice: 0.9998,
      validSupportAmount: 0.4,
      validTargetPrice: null,
      validSelectConfigName: null,
      config: [],
      configs: [],
      resultRaw: [],
      supportPrice: 0.9998,
      supportAmount: 0.4,
      targetPrice: null,
      headerConfig: [
        {
          text: 'Exchange',
          sortable: false,
          value: 'exchange'
        },
        { text: 'Execution Bot', value: 'execution' , sortable: false, },
        { text: 'Support Bot', value: 'support' , sortable: false, },
        { text: 'Open Order Bot', value: 'openOrder' , sortable: false, },
      ],
      headerResult: [
        {
          text: 'Exchange',
          value: 'exchangeName'
        },
        {
          text: 'Market',
          value: 'market'
        },
        {
          text: 'Orders',
          value: 'orders'
        },
        {
          text: 'Volume Token',
          value: 'volumeToken'
        },
        {
          text: 'Volume Quote',
          value: 'volumeQuote'
        },
        {
          text: 'Volume USD',
          value: 'volumeUSD'
        },
        {
          text: 'Buy/Amount',
          value: 'buyOrders'
        },
        {
          text: 'Support/Amount',
          value: 'supportOrders'
        }
      ],
      result: []
      }
    },
  async beforeMount () {
    this.loading = true
    try {
      let result = await this.service.find({ limit: 100 , sort: { client: 1 }})
      result = result.map(item =>  {
        const execution = item.buybackAccounts ? item.buybackAccounts.map (acc => acc.account_id) : []
        const support = item.accountsSupport ? item.accountsSupport.map (acc => acc.account_id) : []
        const openOrder = item.accountsOpenOrders ? item.accountsOpenOrders.map (acc => acc.account_id) : []
        const exchange = item.exchanges ? item.exchanges.map (exchangeObject => {
          return exchangeObject.name
        }) : []
        return {
          name: item.id,
          description: item.description,
          updated_at: item.updated_at,
          exchange,
          support,
          openOrder,
          execution
        }
      })
      this.configs.push(...result)
    } catch (e) { console.log('Buyback get configs : ' + e) }
    this.loading = false
  },
    computed: {
  validForm() {
    return this.supportPrice && this.supportAmount && this.targetPrice && this.selected;
  },
  selectConfigs() {
    const data = this.configs.filter(item => this.selected === item.name)
    const exchangeAccounts = data[0].exchange.map((exchange) => {
  return {
    exchange: [exchange],
    support: data[0].support.filter((account) => account.includes(exchange)),
    openOrder: data[0].openOrder.filter((account) => account.includes(exchange)),
    execution: data[0].execution.filter((account) => account.includes(exchange))
    }
  })
    const result = {
      clientConfigName: data[0].name,
      description: data[0].description,
      updated_at: data[0].updated_at,
      exchanges: exchangeAccounts
    }

    this.config = [result]
    return exchangeAccounts
  },
  isResultEmpty() {
    return this.result.length === 0;
  }
},
methods: {
  async submitQuery() {
    if (this.validForm) {
      const params = {
      IS_TEST: true,
      targetPrice: this.targetPrice,
      supportOrderPriceRatio: this.supportPrice,
      supportOrderAmountRatio: this.supportAmount,
      clientConfigName: this.selected
      }
      this.loading = true
      try {
        let previousErrorMessage = ''
        let previousErrorTime = 0
        const result = await MongoService.buybackOperation.buyback(params)

        const messagesArray = result.errorMessages || []
        if (messagesArray && messagesArray.length > 0 && (messagesArray[messagesArray - 1] !== previousErrorMessage || Date.now() - previousErrorTime > 1000)) {
          for (const message of messagesArray) {
            MessageDialog.showErrorMessage({
              title: 'Buyback Error',
              text: message
            })
            previousErrorMessage = message
            previousErrorTime = Date.now()
          }
          this.validQuery = false
        } else {
          this.validQuery = true
          this.validSupportPrice = this.supportPrice
          this.validSupportAmount = this.supportAmount
          this.validTargetPrice = this.targetPrice
          this.validSelectConfigName = this.selected
        }
        const mapResult = result.infoMarkets.map((market) => ({
            exchangeName: market.exchange,
            market: `${market.base}/${market.quote}`,
            orders: market.orders,
            volumeToken: market.buy.amount,
            volumeQuote: market.totalVolume,
            volumeUSD: market.totalVolumeUsd,
            buyOrders: `${market.buy.price}$/${market.buy.amount}`,
            supportOrders: `${market.support.price}$/${market.support.amount}`
          }));
        this.result = mapResult
        this.resultRaw = result
        } catch (e) {
          console.log(e)
        }
      this.loading = false
    } else {
      MessageDialog.showErrorMessage({ title: 'Something Wrong', text: 'Contract Dev ASAP' })
    }
  },
  async submitExecution() {
    if (this.validForm && this.validQuery &&  this.validSupportPrice === this.supportPrice && this.validSupportAmount === this.supportAmount && this.validTargetPrice === this.targetPrice && this.validSelectConfigName === this.selected) {
      const params = {
      IS_TEST: false,
      targetPrice: this.targetPrice,
      supportOrderPriceRatio: this.supportPrice,
      supportOrderAmountRatio: this.supportAmount,
      clientConfigName: this.selected
      }
      const totalAmount = this.resultRaw.totalUsdToBuy ? this.resultRaw.totalUsdToBuy : 0
      const confirm = await MessageDialog.showConfirmMessageWithType({
        title: 'Are You Sure ?',
        text: `Total Amount: ${totalAmount}`,
        totalAmount })
      if (confirm) {
        try {
          const result = await MongoService.buybackOperation.buyback(params)
          console.log(result)
        } catch (e) {
          console.log(e)
        }
      }
  }
}
},
}
</script>

<style>
.custom-style-for-table {
  font-size: 15px;
  padding: 3px;
}

</style>
